module.exports = __webpack_public_path__ + "img/logo-mobradio-black.b95babc2.png";